
import { Injectable} from '@angular/core';
import { JwtHelperService } from "@auth0/angular-jwt";
// import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { DataService } from './data.service';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { CommonFunctionService } from './Common/common-function.service';
import { pipe } from 'rxjs';
import { map } from 'rxjs';
@Injectable()
export class AuthService {
  currentuser: any;
  url: any;
  token:any;
  headers:any;
  constructor(private data: DataService, private helper: JwtHelperService,private commonfunction: CommonFunctionService,private http: HttpClient) {}


  poslogin(credentials:any) {
    const user = this.data.posauthenticate(
      environment.posauthenticationUrl,
      credentials
    );
    this.currentuser = user;
    return user;
  }


  login(credentials) { 
    const user = this.data.authenticate(
      environment.authenticationUrl,
      credentials
    );
    this.currentuser = user;
    return user;
  }
  loginSupportUser(credentials) {
    const user = this.data.authenticateSupportUser(
      environment.supportLoginUrl,
      credentials,
    );
    this.currentuser = user;
    return user;
  }
  
  signup(credentials) {
    // Set User Type as Reseller User
    credentials.UserType = 'Merchant';
    return this.data
      .create(environment.singupUrl, credentials)
     .pipe(map(response => {
        const result = JSON.stringify(response);
        console.log('auth service - sign up result', result);
        if (result) {
          return result;
        } else { return false; }
      }));
  }

  fileUpload(credentials) {
    // Set User Type as Reseller User
    credentials.UserType = 'Merchant';
    return this.data
      .create(environment.fileUploadUrl, credentials)
      .pipe(map(response => {
        const result = JSON.stringify(response);
        console.log('auth service - sign up result', result);
        if (result) {
          return result;
        } else { return false; }
      }));
  }

  userSignup(credentials) {
    // Set User Type as Reseller User
    credentials.UserType = 'MerchantUser';
    return this.data
      .create(environment.userSignupUrl, credentials)
      .pipe(map(response => {
        const result = JSON.stringify(response);
        console.log('auth service - sign up result', result);
        if (result) {
          return result;
        } else { return false; }
      }));
  }

  createMerchant(credentials) {
    // Set User Type as Reseller User
    credentials.UserType = 'Merchant';
    return this.data
      .create(environment.createNewMerchantUrl, credentials)
      .pipe(map(response => {
        const result = JSON.stringify(response);
        console.log('auth service - sign up result', result);
        if (result) {
          return result;
        } else { return false; }
      }));
  }

  logout() {
    localStorage.removeItem('VirtualPOSToken');
    this.currentuser = null;
  }

  isLoggedIn() {
    
    // if(localStorage.getItem("VirtualPOSToken")==null)
    // {
    //   return false;
    // }
    // return this.helper.isTokenExpired('VirtualPOSToken');

    const token: string = localStorage.getItem('VirtualPOSToken');
    return token != null && !this.helper.isTokenExpired(token);
  }
}

